"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTypeToJSON = exports.ActionTypeFromJSONTyped = exports.ActionTypeFromJSON = exports.ActionType = void 0;
/**
 * Action type, Determines whether given action is Required or Optional to enter Giveaway. Also indicates whether given action result is Persistent (doesn't need to be repeated) or Transient (needs to be repeatedly done) by the Entrant
 * @export
 */
exports.ActionType = {
    RequiredPersistent: 'REQUIRED_PERSISTENT',
    RequiredTransient: 'REQUIRED_TRANSIENT',
    OptionalPersistent: 'OPTIONAL_PERSISTENT',
    OptionalTransient: 'OPTIONAL_TRANSIENT',
    GlobalRequiredPersistent: 'GLOBAL_REQUIRED_PERSISTENT'
};
function ActionTypeFromJSON(json) {
    return ActionTypeFromJSONTyped(json, false);
}
exports.ActionTypeFromJSON = ActionTypeFromJSON;
function ActionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ActionTypeFromJSONTyped = ActionTypeFromJSONTyped;
function ActionTypeToJSON(value) {
    return value;
}
exports.ActionTypeToJSON = ActionTypeToJSON;
